module.exports = __webpack_public_path__ + "84dae63367ee598022512f13cfa8a7f8.jpg";